import AuditInput from "./AuditInput";

const AUDIT_DIMENSIONS = [
  { label: "Answer Engine (AEO)", score: 72, color: "bg-primary" },
  { label: "Generative Search (GEO)", score: 64, color: "bg-secondary" },
  { label: "AI Integration (AIO)", score: 58, color: "bg-tertiary" },
  { label: "Crawlability", score: 81, color: "bg-emerald-500" },
  { label: "Search Experience (SXO)", score: 69, color: "bg-blue-500" },
];

const AuditScoreVisual = () => (
  <div className="rounded-[2.5rem] shadow-2xl w-full ring-1 ring-outline-variant/10 bg-surface-container-low p-6 space-y-4">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-xs font-bold text-primary uppercase tracking-tighter mb-1">
          LLM SEO Score
        </p>
        <div className="flex items-end gap-2">
          <span className="font-headline text-5xl font-extrabold text-on-surface">68</span>
          <span className="text-on-surface-variant text-lg font-medium mb-1">/ 100</span>
        </div>
      </div>
      <div className="text-right">
        <span className="inline-block px-3 py-1 rounded-full bg-yellow-500/15 text-yellow-500 text-xs font-bold">
          Needs Work
        </span>
      </div>
    </div>
    <div className="h-px bg-surface-container-high" />
    <div className="space-y-3">
      {AUDIT_DIMENSIONS.map((d) => (
        <div key={d.label}>
          <div className="flex justify-between text-xs mb-1">
            <span className="text-on-surface-variant font-medium">{d.label}</span>
            <span className="font-bold text-on-surface">{d.score}</span>
          </div>
          <div className="h-1.5 w-full bg-surface-container-high rounded-full overflow-hidden">
            <div className={`h-full rounded-full ${d.color}`} style={{ width: `${d.score}%` }} />
          </div>
        </div>
      ))}
    </div>
    <p className="text-xs text-on-surface-variant/60 text-center">
      Example audit — your score will reflect your actual site
    </p>
  </div>
);

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden pt-10 pb-32 px-8" id="audit-section">
      <div className="max-w-8xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
        {/* Left Column */}
        <div className="lg:col-span-7">
          <span className="inline-block py-1 px-3 bg-surface-container-high text-primary font-label text-xs font-bold tracking-widest uppercase rounded-full mb-6">
            AI-Era Search Intelligence
          </span>

          <h1 className="font-headline text-5xl lg:text-7xl font-extrabold text-on-surface leading-[1.1] mb-8 tracking-tight">
            Is Your Hotel Ready for <br />
            <span className="text-primary italic">AI-Powered Search?</span>
          </h1>

          <p className="text-on-surface-variant text-xl max-w-xl mb-12 leading-relaxed">
            The only audit built for hospitality that scores your website across Answer Engines,
            Generative Search, and AI Integration — so you can fix what matters before your
            competitors do.
          </p>

          <AuditInput />
        </div>

        {/* Right Column */}
        <div className="lg:col-span-5 relative">
          <AuditScoreVisual />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
